import CurrencyBaseWidget from './currencies_base_widget'

class CurrenciesDropdown extends CurrencyBaseWidget {
  static async init () {
    return new CurrenciesDropdown()
  }

  constructor () {
    super('.currencies .dropdown-menu a')

    const selectedCurrency = (this.selectedCurrency() || this.$currencyLinks.first().data('currency') || '').toUpperCase()
    const $selectedElem = this.$currencyLinks.filter(`[data-currency='${selectedCurrency}']`)

    if ($selectedElem[0]) {
      this.$currencyLinks.removeClass('active')
      $selectedElem.addClass('active')
      $('#currency_dropdown').text($selectedElem.data('currency-label') || selectedCurrency)
    }
  }
}

export default CurrenciesDropdown
